/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, createRef, useState } from "react";

import MaterialTablePicker from "components/MaterialTablePicker";

import { useDispatch, useSelector } from "react-redux";

// Store
import setAlert from "store/actions/alertActions";

import {
  deletePromotion,
  updatePromotion,
  clearErrors,
  deleteSinglePromotion,
} from "store/actions/promotionActions";
import Grid from "@mui/material/Grid2";
import Footer from "components/Footer";
import DashboardNavbar from "components/DashboardNavbar";
import columnsMap from "components/MaterialTablePicker/TableColumns";
import DashboardLayout from "layouts/DashboardLayout";
import { getUserPartnerLocations, setLoading, setLocation } from "store/actions/locationAction";

import LocationUserPartner from "components/locations/LocationUserPartner";
import { getPdf, getCsv } from "store/actions/exportAction";
import form from "../new-promotion/schemas/form";

// Store

const Promotions = () => {
  const { location } = form.formField;

  const tableRef = createRef();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.promotions.loading);
  const error = useSelector((state) => state.promotions.error);
  const promotions = useSelector((state) => state.promotions.promotions);
  const user = useSelector((state) => state.users.user);
  const locations = useSelector((state) => state.locations.locations);
  const locationPartner = useSelector((state) => state.locations.location);

  const [locationId, setLocationId] = useState("");
  const [initialized, setInitialized] = useState(false);

  // Fetch initial data based on user role
  useEffect(() => {
    dispatch(deleteSinglePromotion());
    if (user?.role === "partner") {
      dispatch(setLoading());
      dispatch(getUserPartnerLocations());
    }
  }, [user?.role]);

  useEffect(() => {
    if (!initialized && user?.role === "partner") {
      if (locationPartner) {
        setLocationId(locationPartner);
        setInitialized(true);
      } else if (locations?.length > 0) {
        setLocationId(locations[0]._id);
        setInitialized(true);
      }
    }
  }, [locations, initialized, user?.role]);

  useEffect(() => {
    if (promotions?.length > 0) tableRef.current?.onQueryChange();
  }, [promotions?.length]);

  // Handle location change for partners
  const handleChange = (option, selectedLocation) => {
    if (selectedLocation?._id) {
      setLocationId(selectedLocation._id);
      dispatch(setLocation(selectedLocation._id));
      tableRef.current?.onQueryChange();
    }
  };

  const deletePromotionFn = (id) => {
    dispatch(deletePromotion(id));
  };

  const updatePromotionFn = (data) => {
    const updatedData = { _id: data._id, title: data.title };
    dispatch(updatePromotion(updatedData));
  };

  useEffect(() => {
    if (error) {
      dispatch(setAlert(error, "error"));
      dispatch(clearErrors());
    }
  }, [error, setAlert]);

  const columns = [
    columnsMap.titleCol,
    columnsMap.recommendationName,
    columnsMap.locationName,
    columnsMap.startDateWithFilter,
    columnsMap.endDateWithFilter,
  ];
  const partnerColumns = [
    columnsMap.titleCol,
    columnsMap.recommendationName,
    columnsMap.startDateWithFilter,
    columnsMap.endDateWithFilter,
  ];

  const getApiUrl = () => {
    if (user?.role === "admin") {
      return `${process.env.REACT_APP_API}/promotions?`;
    }
    return locationId ? `/v2/locations/${locationId}/promotions?` : null;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container pt={3}>
        <Grid size={{ xs: 4 }}>
          {user?.role === "partner" && locations.length > 0 && (
            <LocationUserPartner
              defaultLocationId={locationId}
              handleChange={handleChange}
              locations={locations || {}}
              location={location}
            />
          )}
        </Grid>

        <Grid size={{ xs: 12 }}>
          {((user.role === "partner" && locationId) || user.role === "admin") && (
            <MaterialTablePicker
              screen="PromotionsList"
              title=""
              columns={user?.role === "admin" ? columns : partnerColumns}
              extraFields="placeName"
              tableRef={tableRef}
              asyncTable
              sortField="title"
              searchField="promotions"
              exportMenuField="promotions"
              idSynonymName="_id"
              onRowClickURL={`/${user.role}/promotions`}
              currentUrl="promotions"
              asyncURL={getApiUrl()}
              addUrl="promotions/new-promotion"
              actionsName="Promotion"
              editableUpdate={updatePromotionFn}
              editableDelete={deletePromotionFn}
              isLoading={loading}
              updateRoleAction
              deleteRoleAction
              editableRole={user.role === "admin"}
              actionsRole={user.role === "admin" || user.role === "partner"}
              getPdf={(value, query) => {
                if (value) {
                  if (user?.role === "partner") {
                    dispatch(
                      getPdf(
                        value,
                        `locations/${locationId}/promotions/createPdf${query}&pdf=true&fields=title,recommendation,location,startDate,endDate,source`,
                        "Promotions"
                      )
                    );
                  } else {
                    dispatch(
                      getPdf(
                        value,
                        `stats/pdf${query}&fields=title,recommendation,location,startDate,endDate,source`,
                        "Promotions"
                      )
                    );
                  }
                } else {
                  // Handle the case where 'value' is undefined or empty
                  console.error("Error: No data for PDF export.");
                }
              }}
              getCsv={(value, query) => {
                if (value) {
                  if (user?.role === "partner") {
                    dispatch(
                      getCsv(
                        `${process.env.REACT_APP_API}/locations/${locationId}/promotions/csv${query}&csv=true&fields=title,recommendation,location,startDate,endDate,source,placeName`,
                        "Promotions"
                      )
                    );
                  } else {
                    dispatch(
                      getCsv(
                        value,
                        `stats/csv${query}&fields=title,recommendation,location,startDate,endDate,source`,
                        "Promotions"
                      )
                    );
                  }
                } else {
                  // Handle the case where 'value' is undefined or empty
                  console.error("Error: No data for CSV export.");
                }
              }}
            />
          )}
        </Grid>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
};

export default Promotions;
